module.exports = __webpack_public_path__ + "static/img/36.288ad61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/36.png
// module id = hL9n
// module chunks = 0